<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      @click="openEditSensitiveWordDialog(true)"
      >新增敏感词</el-button
    >

    <el-table
      :data="sensitiveWordsTableData"
      border
      size="small"
      style="width: 500px"
    >
      <el-table-column prop="sensitiveWord" label="敏感词" align="center" width="300">
      </el-table-column>
      <el-table-column label="" align="center" width="200">
        <template scope="scope">
          <el-button
            type="danger"
            round
            size="small"
            @click="onClickDeleteSensitiveWordBtn(scope.row.sensitiveWord)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加/修改敏感词”对话框 -->
    <EditSensitiveWordDialog
      v-if="shouldEditSensitiveWordDialogVisible"
      @close="onEditSensitiveWordDialogClosed()"
      :value="valueForEditSensitiveWordDialog"
    ></EditSensitiveWordDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("../../util");

import EditSensitiveWordDialog from "./EditSensitiveWordDialog";

export default {
  data() {
    return {
      shouldEditSensitiveWordDialogVisible: false, // “添加/修改敏感词”对话框是否应该显示出来
      valueForEditSensitiveWordDialog: null, // 要传递给“添加/修改敏感词”对话框的数据
      sensitiveWordsTableData: [], // 敏感词列表里展示的数据
    };
  },

  created() {
    this.loadSensitiveWordList();
  },

  components: {
    EditSensitiveWordDialog,
  },

  methods: {
     onClickDeleteSensitiveWordBtn(sensitiveWord) {
        this.$confirm("此操作将删除该敏感词，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            await this.deleteSensitiveWord(sensitiveWord);

            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          }); 
    },
    
    /**
     * 查询敏感词集合
     */
    async loadSensitiveWordList() {
      let resData = (
        await axios.post(`${util.getBackendApiBase()}/v1/getSensitiveWordList`, {}, {
          headers: {
            token: util.getLoginUserToken(),
          },
        })
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let listInResp = resData.data.sensitiveWordList || [];

      let list = [];
      for (let e of listInResp) {
        list.push({
          sensitiveWord: e,
        })
      }

      this.sensitiveWordsTableData = list;
    },

    /**
     * 删除一个敏感词
     */
    async deleteSensitiveWord(sensitiveWord) {
      let resData = (
        await axios.post(`${util.getBackendApiBase()}/v1/deleteSensitiveWord`, {
          sensitiveWord: sensitiveWord,
        }, {
          headers: {
            token: util.getLoginUserToken(),
          },
        })
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      // 重新拉敏感词集合
      return this.loadSensitiveWordList();
    },

    /**
     * 打开“添加/修改敏感词”对话框
     */
    async openEditSensitiveWordDialog(isCreate, oldData) {
      this.shouldEditSensitiveWordDialogVisible = true;
      this.valueForEditSensitiveWordDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “添加/修改敏感词”对话框关闭了
     */
    async onEditSensitiveWordDialogClosed() {
      this.shouldEditSensitiveWordDialogVisible = false;

      // 重新拉敏感词集合
      return this.loadSensitiveWordList();
    },
  },
};
</script>